export default __webpack_public_path__ + "static/media/verification-blue.ab4e4435.svg";